const STORAGE_KEY = 'sk_wishlist';

// ── Storage ────────────────────────────────────────────────

function getList() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); }
  catch { return {}; }
}

function saveList(list) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: Object.keys(list).length } }));
}

function getHandle(meta) {
  if (meta.handle) return meta.handle;
  if (meta.url) {
    const m = meta.url.match(/\/products\/([^/?#]+)/);
    if (m) return m[1];
  }
  return '';
}

function toggleItem(id, meta) {
  const list = getList();
  if (list[id]) {
    delete list[id];
  } else {
    list[id] = { ...meta, handle: getHandle(meta) };
  }
  saveList(list);
  return !!list[id];
}

function isWishlisted(id) { return !!getList()[String(id)]; }
function getCount() { return Object.keys(getList()).length; }

// ── Count badges ───────────────────────────────────────────

function updateBadges() {
  const count = getCount();
  document.querySelectorAll('.js-wishlist-count').forEach(el => {
    el.textContent = count;
    el.classList.toggle('hidden', count === 0);
  });
}

// ── Button state ───────────────────────────────────────────

function syncBtn(btn) {
  const wishlisted = isWishlisted(btn.dataset.productId);
  btn.classList.toggle('is-wishlisted', wishlisted);
  btn.setAttribute('aria-label', wishlisted ? 'Видалити зі списку бажань' : 'Додати до списку бажань');
}

function initAllButtons() {
  document.querySelectorAll('.js-wishlist-btn').forEach(syncBtn);
}

// ── Click delegation ────────────────────────────────────────

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.js-wishlist-btn');
  if (!btn || !btn.dataset.productId) return;

  const id = String(btn.dataset.productId);
  const meta = {
    handle: btn.dataset.productHandle || '',
    title:  btn.dataset.productTitle  || '',
    price:  parseInt(btn.dataset.productPrice, 10) || 0,
    image:  btn.dataset.productImage  || '',
    url:    btn.dataset.productUrl    || '',
  };

  toggleItem(id, meta);
  document.querySelectorAll(`.js-wishlist-btn[data-product-id="${id}"]`).forEach(syncBtn);
});

// ── Sort helpers ───────────────────────────────────────────

function getSortBy() {
  const el = document.querySelector('.js-wishlist-sort:checked');
  return el ? el.value : 'featured';
}

function sortItems(items, sortBy) {
  const arr = [...items];
  switch (sortBy) {
    case 'price-asc':  arr.sort((a, b) => a.price - b.price); break;
    case 'price-desc': arr.sort((a, b) => b.price - a.price); break;
    case 'title-asc':  arr.sort((a, b) => (a.title || '').localeCompare(b.title || '')); break;
    case 'title-desc': arr.sort((a, b) => (b.title || '').localeCompare(a.title || '')); break;
  }
  return arr;
}

// ── Wishlist page ──────────────────────────────────────────

function applyGridStyles(grid) {
  const w = window.innerWidth;
  let cols, gap;
  if (w >= 990) {
    cols = 'repeat(4, 1fr)'; gap = '28px 20px';
  } else if (w >= 750) {
    cols = 'repeat(3, 1fr)'; gap = '28px 24px';
  } else {
    cols = 'repeat(1, 1fr)'; gap = '24px 0';
  }
  grid.style.display = 'grid';
  grid.style.gridTemplateColumns = cols;
  grid.style.gap = gap;
  grid.style.listStyle = 'none';
  grid.style.padding = '0';
  grid.style.margin = '0';
}

const WISH_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M15.2754 2.21289C14.5163 2.25586 13.7751 2.44564 13.0518 2.78223C12.3285 3.11882 11.6374 3.55925 10.9786 4.10352C10.3197 3.55925 9.6322 3.12598 8.91606 2.80371C8.19991 2.48145 7.46944 2.29883 6.72465 2.25586C5.89392 2.19857 5.09542 2.31315 4.32914 2.59961C3.56287 2.88607 2.89327 3.31576 2.32035 3.88867C1.74744 4.47591 1.31775 5.14909 1.03129 5.9082C0.744832 6.66732 0.630249 7.4694 0.687541 8.31445C0.730509 9.23112 0.973999 10.1263 1.41801 11C1.86202 11.8737 2.46358 12.6901 3.2227 13.4492L10.0977 20.3457C10.2123 20.4746 10.3483 20.5677 10.5059 20.625C10.6635 20.6823 10.821 20.7109 10.9786 20.7109C11.1504 20.7109 11.3116 20.6787 11.462 20.6143C11.6123 20.5498 11.7448 20.4603 11.8594 20.3457L18.7344 13.4492C19.5079 12.6758 20.1166 11.8486 20.5606 10.9678C21.0046 10.0869 21.2552 9.18815 21.3125 8.27149C21.3698 7.42643 21.2588 6.62077 20.9795 5.85449C20.7002 5.08822 20.2741 4.41862 19.7012 3.84571C19.114 3.27279 18.4372 2.8431 17.6709 2.55664C16.9047 2.27018 16.1062 2.1556 15.2754 2.21289Z" fill="currentColor"/></svg>`;

function esc(s) {
  const d = document.createElement('div');
  d.textContent = String(s || '');
  return d.innerHTML;
}

function extractDescription(html) {
  if (!html) return '';
  try {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
  } catch {
    return '';
  }
}

function escAttr(s) {
  return String(s || '').replace(/"/g, '&quot;');
}

function imgSrc(src) {
  if (!src) return '';
  // Shopify CDN: insert _400x before extension
  return src.replace(/(\.[^./?]+)(\?.*)?$/, '_400x$1$2');
}

function moneyFmt(cents) {
  const n = (cents / 100).toFixed(2);
  const [int, dec] = n.split('.');
  return '\u20b4' + int.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + dec;
}

function productCardHTML(p) {
  const v = p.variants[0];
  const img = imgSrc(p.featured_image || (p.images && p.images[0]));
  const id = String(p.id);
  const compareAt = v.compare_at_price || p.compare_at_price || 0;
  const hasDiscount = compareAt > v.price;
  const discountPct = hasDiscount ? Math.round((compareAt - v.price) * 100 / compareAt) : 0;
  const description = extractDescription(p.description || p.body_html);

  return `
<li class="product-grid__item" data-product-id="${id}" style="display:block;min-width:0;">
  <div class="product-card-wishlist" style="display:flex;flex-direction:column;gap:10px;">
    <a href="/products/${p.handle}" style="display:block;position:relative;width:100%;aspect-ratio:300/380;background:#fff4f3;border-radius:12px;overflow:hidden;">
      ${img ? `<img src="${img}" alt="${escAttr(p.title)}" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block;transition:transform 0.3s ease;" class="product-media__image">` : ''}
      ${hasDiscount ? `<div class="product-badges product-badges--top-left" style="position:absolute;top:12px;left:12px;z-index:2;pointer-events:none;"><div class="product-badges__badge product-badges__badge--rectangle product-badges__badge--discount">ЗНИЖКА -${discountPct}%</div></div>` : ''}
    </a>
    <div class="product-card__extras">
      <div class="product-card__title-row">
        <a href="/products/${p.handle}" class="product-card__custom-title">${esc(p.title)}</a>
        <button
          class="product-card__wishlist button-unstyled js-wishlist-btn is-wishlisted"
          data-product-id="${id}"
          data-product-handle="${p.handle}"
          data-product-title="${escAttr(p.title)}"
          data-product-price="${v.price}"
          data-product-url="/products/${p.handle}"
          aria-label="Видалити зі списку бажань"
        ><span class="svg-wrapper">${WISH_SVG}</span></button>
      </div>
      ${description ? `<p class="product-card__description">${esc(description)}</p>` : ''}
      <div class="product-card__stars">
        <span class="product-card__star product-card__star--filled">★</span>
        <span class="product-card__star product-card__star--filled">★</span>
        <span class="product-card__star product-card__star--filled">★</span>
        <span class="product-card__star product-card__star--filled">★</span>
        <span class="product-card__star">★</span>
      </div>
      <div class="product-card__custom-price">
        <span class="product-card__price-current${hasDiscount ? ' product-card__price-current--sale' : ''}">${moneyFmt(v.price)}</span>
        ${hasDiscount ? `<span class="product-card__price-compare">${moneyFmt(compareAt)}</span>` : ''}
      </div>
      ${v.available
        ? `<button type="button" class="product-card__add-btn" data-variant-id="${v.id}" onclick="(function(btn){btn.disabled=true;btn.textContent='...';fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(btn.dataset.variantId),quantity:1}]})}).then(function(r){return r.json()}).then(function(){btn.textContent='\u2713';var e=new CustomEvent('cart:update',{bubbles:true,detail:{resource:{item_count:null}}});document.dispatchEvent(e);setTimeout(function(){btn.textContent='\u0414\u043e\u0434\u0430\u0442\u0438 \u0432 \u043a\u043e\u0448\u0438\u043a';btn.disabled=false;},1500)}).catch(function(){btn.textContent='\u0414\u043e\u0434\u0430\u0442\u0438 \u0432 \u043a\u043e\u0448\u0438\u043a';btn.disabled=false;})})(this)">Додати в кошик</button>`
        : `<button class="product-card__add-btn product-card__add-btn--disabled" disabled>Розпродано</button>`
      }
    </div>
  </div>
</li>`;
}

// All fetched products cached for search filtering
let _wishlistProducts = [];

function getSearchQuery() {
  const el = document.getElementById('js-wishlist-search');
  return el ? el.value.trim().toLowerCase() : '';
}

function updateCountLabel(count) {
  const el = document.getElementById('js-wishlist-count-label');
  if (el) el.textContent = count + ' ' + pluralUa(count, 'засіб', 'засоби', 'засобів');
}

function pluralUa(n, one, few, many) {
  const mod10 = n % 10, mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return few;
  return many;
}

function renderFilteredGrid() {
  const grid = document.getElementById('wishlist-product-grid');
  if (!grid) return;
  const q = getSearchQuery();
  const filtered = q
    ? _wishlistProducts.filter(p => (p.title || '').toLowerCase().includes(q))
    : _wishlistProducts;
  const cards = filtered.map(productCardHTML).join('');
  grid.innerHTML = cards || '<li style="list-style:none;padding:20px;color:#999;">Нічого не знайдено</li>';
  applyGridStyles(grid);
  grid.querySelectorAll('.js-wishlist-btn').forEach(syncBtn);
  updateCountLabel(filtered.length);
}

async function renderWishlistPage(sortBy) {
  const emptyEl  = document.getElementById('wishlist-empty');
  const gridWrap = document.getElementById('wishlist-grid-wrapper');
  const grid     = document.getElementById('wishlist-product-grid');
  const toolbar  = document.getElementById('wishlist-toolbar');
  if (!grid) return;

  const items = sortItems(Object.values(getList()), sortBy || getSortBy());
  const handles = items.map(getHandle).filter(Boolean);

  if (handles.length === 0) {
    emptyEl?.classList.remove('hidden');
    gridWrap?.classList.add('hidden');
    if (toolbar) toolbar.style.display = 'none';
    _wishlistProducts = [];
    return;
  }

  emptyEl?.classList.add('hidden');
  gridWrap?.classList.remove('hidden');
  if (toolbar) toolbar.style.display = 'flex';
  grid.innerHTML = '<li style="list-style:none;padding:20px;color:#999;">Завантаження...</li>';

  const products = await Promise.all(
    handles.map(h =>
      fetch(`/products/${h}.js`)
        .then(r => r.ok ? r.json() : null)
        .catch(() => null)
    )
  );

  _wishlistProducts = products.filter(Boolean);
  renderFilteredGrid();
}

function initSortListeners() {
  document.querySelectorAll('.js-wishlist-sort').forEach(radio => {
    radio.addEventListener('change', () => renderWishlistPage(radio.value));
  });

  const searchEl = document.getElementById('js-wishlist-search');
  if (searchEl) {
    searchEl.addEventListener('input', () => renderFilteredGrid());
  }
}

function initMobileSortDrawer() {
  const trigger  = document.querySelector('.js-wishlist-sort-trigger');
  const overlay  = document.querySelector('.js-wishlist-sort-overlay');
  const drawer   = document.querySelector('.js-wishlist-sort-drawer');
  const closeBtn = document.querySelector('.js-wishlist-sort-drawer-close');
  if (!trigger || !drawer) return;

  function openDrawer() {
    overlay?.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    overlay?.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  trigger.addEventListener('click', openDrawer);
  overlay?.addEventListener('click', closeDrawer);
  closeBtn?.addEventListener('click', closeDrawer);

  drawer.querySelectorAll('.js-wishlist-sort-mobile').forEach(radio => {
    radio.addEventListener('change', () => {
      closeDrawer();
      renderWishlistPage(radio.value);
    });
  });
}

// ── Events ─────────────────────────────────────────────────

window.addEventListener('wishlist:updated', () => {
  updateBadges();
  if (document.getElementById('wishlist-product-grid')) {
    renderWishlistPage();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  updateBadges();
  initAllButtons();

  if (document.getElementById('wishlist-product-grid')) {
    renderWishlistPage('featured');
    initSortListeners();
    initMobileSortDrawer();

    window.addEventListener('resize', () => {
      const grid = document.getElementById('wishlist-product-grid');
      if (grid && grid.children.length > 0) applyGridStyles(grid);
    });
  }
});
